export interface Integration {
  id: string;
  name: string;
  logo: string;
  status: "error" | "synced";
  lastRun: string;
  nextRun?: string;
}

export const integrations: Integration[] = [
  {
    id: "1",
    name: "ConnectWise PSA",
    logo: "",
    status: "error",
    lastRun: "01/02/2025 @ 10:08 UTC",
    nextRun: undefined,
  },
  {
    id: "2",
    name: "Sage 200",
    logo: "",
    status: "synced",
    lastRun: "01/02/2025 @ 10:08 UTC",
    nextRun: "01/02/2025 @ 10:08 UTC",
  },
  {
    id: "3",
    name: "Cisco Meraki",
    logo: "",
    status: "synced",
    lastRun: "01/02/2025 @ 10:08 UTC",
    nextRun: "01/02/2025 @ 10:08 UTC",
  },
  {
    id: "4",
    name: "Quickbooks",
    logo: "",
    status: "error",
    lastRun: "01/02/2025 @ 10:08 UTC",
    nextRun: undefined,
  },
  {
    id: "5",
    name: "Trello",
    logo: "",
    status: "synced",
    lastRun: "01/02/2025 @ 10:08 UTC",
    nextRun: "01/02/2025 @ 10:08 UTC",
  },
];


